import {Section} from 'common/components/items-menu/types';

export enum MultiAttributionType {
  FirstTouch = `first_touch`,
  LastTouch = `last_touch`,
  Linear = `linear`,
  Participation = `participation`,
  UShaped = `u_shaped`,
  JShaped = `j_shaped`,
  InverseJShaped = `inverse_j_shaped`,
  Custom = `custom`,
}

export type MultiAttributionWeights = {
  /** Percentage values from 0-100. Adds up to 100. */
  first: number;
  middle: number;
  last: number;
};

export type CustomMultiAttribution = {
  name: string;
  type: MultiAttributionType.Custom;
  weights: MultiAttributionWeights;
};

export type PredefinedMultiAttribution = {
  type: Exclude<MultiAttributionType, MultiAttributionType.Custom>;
  weights?: MultiAttributionWeights;
};

export type MultiAttribution = PredefinedMultiAttribution | CustomMultiAttribution;

export type MultiAttributionChangeEvent = CustomEvent<{
  multiAttribution: MultiAttribution;
}>;

export type MultiAttributionCancelEvent = CustomEvent<EmptyObj>;

export type MultiAttributionDeleteEvent = CustomEvent<EmptyObj>;

export const RemoveAttributionValue = `remove_attribution`;

export type MultiAttributionMenuValue = MultiAttributionType | typeof RemoveAttributionValue;
export type MultiAttributionSection = Section<MultiAttributionMenuValue>;
export type MultiAttributionSectionItem = MultiAttributionSection['items'][number];
